import { connect } from 'react-redux';
import { withProps, compose, withState } from 'recompose';

const mapStateToProps = (state) => {
  const {
    hideECommerce,
    pbxScriptLoaded = false,
    userDetail: {
      printbox_session_id = null,
    } = {},
    productPagePath,
    productPageHref,
  } = state;

  return {
    editor: {
      hideECommerce,
      pbxScriptLoaded,
    },
    sessionId: printbox_session_id,
    productPagePath,
    productPageHref,
  };
};

export const withEditorState = compose(
  withState('authUserRequestCalled', 'setAuthCalled', false),
  connect(mapStateToProps),

);



// WEBPACK FOOTER //
// ./src/Common/Editor/withEditorState.js